import React from 'react';

import { type BaseCurrencyType } from '@pkg/types';

import { CurrencyIcon } from '../CurrencyIcon';

import { IconWrapper, Label, StyledCurrencyChip, Symbol } from './CurrencyChip.style';

export interface CurrencyChipProps {
    currency: BaseCurrencyType;
    value?: string | number;
    maxLength?: number;
}

export function CurrencyChip({ currency, value = 0, maxLength }: CurrencyChipProps) {
    const formatted = maxLength ? value.toString().slice(0, maxLength).replace(/\.$/, '') : value;

    return (
        <StyledCurrencyChip>
            <Symbol>
                <IconWrapper>
                    <CurrencyIcon currency={currency} theme="light" />
                </IconWrapper>
            </Symbol>

            <Label>{formatted}</Label>
        </StyledCurrencyChip>
    );
}
